<div class="sidenav-cart-inner-wrapper">
    <div class="cart-table-wrapper">
        <app-delivery-items-table
        [mobileStylesOnly]="true" 
        [first]="true" [orderLines]="order?.lines" [inCart]="true"></app-delivery-items-table>
      </div>
</div>